"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var diveKeyboard_sidecar_1 = require("@voyage/input/diveKeyboard-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var _isMiddleMouseDown = false;
var _mx = 0;
var _my = 0;
var _sx = 0;
var _sy = 0;
function update(obj) {
    // Uncomment to disable camera movement on main menu
    // if (voyageMenuMain.get().isOpen) {
    //   return
    // }
    if (clickEater_sidecar_1.clickEater.isCursorEaten()) {
        return;
    }
    var ap = common_sidecar_1.common.getPhaserScene().game.input.activePointer;
    if (ap.middleButtonDown()) {
        if (!_isMiddleMouseDown) {
            _isMiddleMouseDown = true;
            _mx = ap.x;
            _my = ap.y;
            _sx = obj.cameraX;
            _sy = obj.cameraY;
        }
        voyageCamera_sidecar_1.voyageCamera.setCameraXY(_sx + -(ap.x - _mx), _sy + -(ap.y - _my));
    }
    else {
        _isMiddleMouseDown = false;
        var dt = common_sidecar_1.common.getUpdateDelta();
        var speed = 1000;
        var dirX = 0;
        var dirY = 0;
        var keys = diveKeyboard_sidecar_1.diveKeyboard.getKeys();
        if (voyageGameManager_sidecar_1.voyageGameManager.get().mode === 'body-align') {
        }
        else {
            if (keys.cameraLeft) {
                dirX -= speed;
            }
            if (keys.cameraRight) {
                dirX += speed;
            }
            if (keys.cameraUp) {
                dirY -= speed;
            }
            if (keys.cameraDown) {
                dirY += speed;
            }
        }
        voyageCamera_sidecar_1.voyageCamera.setCameraXY(obj.cameraX + dirX * dt, obj.cameraY + dirY * dt);
    }
}
exports.update = update;
